import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { ReportOption } from 'app/core/models/report-option.model';
import { ReportAbstractOptionComponent } from 'app/shared/components/report-abstract-option/report-abstract-option.component';
import { NgSelectComponent } from '@ng-select/ng-select';
import { UserActivityOption, userActivityOptions } from 'app/core/options/user-activities.opts';

export class ReportUserActivityOption implements ReportOption {
  value: string[];

  constructor(value: string[]) {
    this.value = value;
  }

  toPostData(options = { paramName: 'activity' }) {
    return { [options.paramName]: this.value };
  }
}

@Component({
  selector: 'app-report-user-activity-option',
  templateUrl: './report-user-activity-option.component.html',
  styleUrls: ['./report-user-activity-option.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => ReportUserActivityOptionComponent),
    },
  ],
  imports: [NgSelectComponent, FormsModule]
})
export class ReportUserActivityOptionComponent extends ReportAbstractOptionComponent {
  @Input() label = 'Filter by User Activity';
  @Input() multiple = true;

  userActivityOptions = userActivityOptions;

  selectedUserActivities: string[];

  public get userActivities(): UserActivityOption[] {
    return this.userActivityOptions;
  }

  protected updateInternalState(model: ReportUserActivityOption) {
    if (model) {
      this.selectedUserActivities = model.value;
    }
  }

  protected determineModelStateOnChange(): ReportUserActivityOption {
    if (this.selectedUserActivities &&
        (!Array.isArray(this.selectedUserActivities) ||
        this.selectedUserActivities.length > 0)) {
      return new ReportUserActivityOption(this.selectedUserActivities);
    } else {
      return null;
    }
  }

}